import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { usePageTitle } from '../context/PageTitleContext';
import './Services.scss';

function Services() {
  const { user } = useSelector(state => state.auth);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const { setPageTitle } = usePageTitle();

  // Set page title when component mounts
  useEffect(() => {
    setPageTitle("My Services");
  }, [setPageTitle]);

  useEffect(() => {
    fetchActiveServices();
  }, [user]);

  const fetchActiveServices = async () => {
    if (!user?.uid) return;
    
    setLoading(true);
    try {
      // Get completed orders (these are active services)
      const q = query(
        collection(db, 'orders'),
        where('userId', '==', user.uid),
        where('status', '==', 'completed')
      );
      
      const querySnapshot = await getDocs(q);
      const servicesData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setServices(servicesData);
    } catch (error) {
      console.error('Error fetching services:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderServiceStatus = (service) => {
    // Calculate days since purchase
    const purchaseDate = service.paidAt ? new Date(service.paidAt) : new Date(service.createdAt);
    const today = new Date();
    const diffTime = Math.abs(today - purchaseDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays <= 3) {
      return <span className="status processing">Processing</span>;
    } else if (diffDays <= 7) {
      return <span className="status in-progress">In Progress</span>;
    } else {
      return <span className="status active">Active</span>;
    }
  };

  return (
    <div className="services-page">
      {loading ? (
        <div className="loading">Loading your services...</div>
      ) : services.length > 0 ? (
        <div className="services-grid">
          {services.map(service => (
            <div key={service.id} className="service-card">
              <div className="service-header">
                <h3>{service.packageTitle}</h3>
                {renderServiceStatus(service)}
              </div>
              
              <div className="service-details">
                <div className="detail-item">
                  <span className="label">Purchased:</span>
                  <span className="value">
                    {new Date(service.paidAt || service.createdAt).toLocaleDateString()}
                  </span>
                </div>
                
                <div className="detail-item">
                  <span className="label">Quantity:</span>
                  <span className="value">{service.quantity}</span>
                </div>
                
                <div className="detail-item">
                  <span className="label">Order ID:</span>
                  <span className="value">#{service.id.slice(-6)}</span>
                </div>
              </div>
              
              <div className="service-actions">
                <button className="btn btn-secondary">View Details</button>
                <button className="btn btn-primary">Request Support</button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <h3>No active services</h3>
          <p>You don&apos;t have any active services yet.</p>
          <a href="/packages" className="btn btn-primary">Browse Packages</a>
        </div>
      )}
    </div>
  );
}

export default Services; 